import Vue from "vue";
import App from "./App.vue";
import router from "./router/";
import store from "./store/";
import { currency } from './commons/currency'
import { display_date, capitalize, display_value, display_color, display_text_color } from './commons/formater'
import VueResource from 'vue-resource'
import vuetify from './plugins/vuetify'
import VueMuuriGrid from 'vue-muuri-grid';
import VueCookies from 'vue-cookies'
import HighchartsVue from 'highcharts-vue'
import LoadScript from "vue-plugin-load-script";
import Lingallery from 'lingallery';
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import 'font-awesome/css/font-awesome.css'
import './assets/style.css'
import './assets/main.css'

Vue.use(VueCookies)
Vue.use(VueResource);
Vue.use(require('vue-shortkey'))
Vue.use(VueMuuriGrid);
Vue.use(HighchartsVue);
Vue.filter('currency', currency)
Vue.filter('display_date', display_date)
Vue.filter('capitalize', capitalize)
Vue.filter('display_value', display_value)
Vue.filter('display_color', display_color)
Vue.filter('display_text_color', display_text_color)

import currencyInput from './components/general/CurrencyInput';
Vue.component('h-currency-input', currencyInput);
import widgetTemp from '@/components/dashboard/WidgetTemp';
Vue.component('widget-temp', widgetTemp);
Vue.component('lingallery', Lingallery);
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  LoadScript,
  render: h => h(App)
}).$mount("#app");
